const primary = {
  main: '#8751FF',
};

const secondary = {
  main: '#D0D0D1',
};

const red = {
  main: '#FF516A',
};

const green = {
  main: '#1BD072',
};

export const palette = {
  mode: 'dark',
  primary,
  secondary,
  green,
  red,
};
